<template>
  <div>
    <!--              NEW BUTTOM-->
    <div>
      <v-card flat class="disable-scrollbars">
        <v-card-text>
          <v-row style="max-height: 32px">
            <v-col
              class="text-center mt-n5 blue-grey--text"
              cols="12"
              sm="12"
              md="12"
              lg="12"
              xs="12"
            >
              <v-btn-toggle v-model="icon" borderless>
<!--                <v-btn-->
<!--                  value="graphic"-->
<!--                  :disabled="getButtonWallet ? getButtonWallet : false"-->
<!--                  @click="setOptWallet"-->
<!--                >-->
<!--                  <span-->
<!--                    class="hidden-sm-and-down blue-grey&#45;&#45;text m-size-font-12"-->
<!--                    >Carteira</span-->
<!--                  >-->

<!--                  <v-icon size="14" class="blue-grey&#45;&#45;text" right-->
<!--                    >mdi-wallet-outline</v-icon-->
<!--                  >-->
<!--                </v-btn>-->

                <v-btn
                  value="table"
                  :disabled="getButtonOnline ? getButtonOnline : false"
                  @click="setOptOnline"
                >
                  <span
                    class="hidden-sm-and-down blue-grey--text m-size-font-12"
                    >MCX Express</span
                  >

                  <v-icon size="14" class="blue-grey--text" right
                    >mdi-bank-outline</v-icon
                  >
                </v-btn>
<!--                <v-btn value="request">-->
<!--                  <span-->
<!--                    class="hidden-sm-and-down blue-grey&#45;&#45;text m-size-font-12"-->
<!--                    >Solicitar</span-->
<!--                  >-->

<!--                  <v-icon size="14" class="blue-grey&#45;&#45;text m-size-font-12" right-->
<!--                    >mdi-format-align-justify</v-icon-->
<!--                  >-->
<!--                </v-btn>-->
              </v-btn-toggle>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
    <!--              END NEW BUTTON-->
  </div>
</template>

<script>
import { mapHelper } from "@/store/helper";
//import eventBus from "../../main";

export default {
  name: "OptButonToPay",
  data: () => ({
    icon: "graphic"
  }),
  methods: {
    setOptWallet() {
      this.$store.dispatch("setButtonWallet", true);
    },
    setOptOnline() {
      this.$store.dispatch("setButtonOnline", true);
    }
  },
  computed: {
    ...mapHelper
  },
  created() {
    // const self = this;
    //eventBus.$emit("openWpayment");
  }
};
</script>

<style scoped></style>
